// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_you_don_t_have_permission_to_view_this_page_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have permission to view this page.`)
};

const en_us2_you_don_t_have_permission_to_view_this_page_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have permission to view this page.`)
};

const de_de2_you_don_t_have_permission_to_view_this_page_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast keine Berechtigung, diese Seite anzusehen.`)
};

const en_you_don_t_have_permission_to_view_this_page_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have permission to view this page.`)
};

const de_you_don_t_have_permission_to_view_this_page_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast keine Berechtigung, diese Seite anzusehen.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const you_don_t_have_permission_to_view_this_page_1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.you_don_t_have_permission_to_view_this_page_1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("you_don_t_have_permission_to_view_this_page_1", locale)
	if (locale === "en-GB") return en_gb2_you_don_t_have_permission_to_view_this_page_1(inputs)
	if (locale === "en-US") return en_us2_you_don_t_have_permission_to_view_this_page_1(inputs)
	if (locale === "de-DE") return de_de2_you_don_t_have_permission_to_view_this_page_1(inputs)
	if (locale === "en") return en_you_don_t_have_permission_to_view_this_page_1(inputs)
	return de_you_don_t_have_permission_to_view_this_page_1(inputs)
};
export { you_don_t_have_permission_to_view_this_page_1 as "You don't have permission to view this page." }